export const ISLOADING = "ISLOADING";
export const ISLOADER = "ISLOADER";
export const SALDO = "SALDO";
export const ERROR = "ERROR";
export const ISLOGIN = "ISLOGIN";
export const ISREGISTER = "ISREGISTER";
export const EKSTERNALLOGIN = "EKSTERNALLOGIN";
export const HEADER = "HEADER";
export const HOMEPRABAYARCATEGORY = "HOMEPRABAYARCATEGORY";
export const HOMEPASCABAYARCATEGORY = "HOMEPASCABAYARCATEGORY";